/**
 * Blur Placeholder Utility
 * 
 * Provides LQIP (Low Quality Image Placeholder) data URLs for images.
 * These are 16px WebP images, base64 encoded, with blur applied.
 * 
 * Auto-generated by: scripts/generate-blur-placeholders.mjs
 * Last updated: 2026-01-21T12:02:57.075Z
 */

/**
 * Map of image paths to their blur placeholder data URLs.
 * Populate this map with actual generated blur placeholders.
 * 
 * Key: Image path (as used in src prop)
 * Value: Base64 data URL of 16px blurred WebP placeholder
 */
const blurPlaceholderMap: Record<string, string> = {
  '/images/activity arcade/Bento Grid/bento hero mob.webp': 'data:image/webp;base64,UklGRjYAAABXRUJQVlA4ICoAAACwAQCdASoQABAABUB8JYgCdAEOjhCAAPyKb/VTipLmz/EHxcolinCAAAA=',
  '/images/activity arcade/Bento Grid/bento hero pc.webp': 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAADwAQCdASoQABAABUB8JZACdAEfbDscnrQA/pFCcpb3axZ+OfyqZBBmO+/uAAAA',
  '/images/activity arcade/Bento Grid/Restarunt Jungfrau 3_2.webp': 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACwAQCdASoQABAABUB8JZgC7ADv3p4AAP5Xf7Mvex/zWn3u86Sjq6PPCuJEJIAA',
  '/images/activity arcade/Bento Grid/Restarunt Jungfrau 3_2_mobile.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAACwAQCdASoQABAABUB8JZgC7ADst/AAAP5Xf7MvexrRNn4xICOyjn/BwwkgAA==',
  '/images/activity arcade/Bento Grid/Sauna Wide.webp': 'data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAADQAQCdASoQABAABUB8JbACdAEKS3CAAAD+IUS6QsRpCJRGp0V8vvctaVPuBM/ciGAAAA==',
  '/images/activity arcade/Bento Grid/Sauna 3_2_mobile.webp': 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAACwAQCdASoQABAABUB8JbACdAEGncwAAP0cEifcvghpf4g4lS4LiDSjYeR2EN1t4AA=',
  '/images/activity arcade/Bento Grid/Carbon Mountain cafe wide.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAADQAQCdASoQABAABUB8JZgCdAD1V7tIMAD+jOlJ1OfAMs84Ve36ti2jLYKkAA==',
  '/images/activity arcade/Bento Grid/Carbon Mountain Cafe 3_2_mobile.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAADwAQCdASoQABAABUB8JQBOgCHWyPkUIQAA/osXOBXABNycIip9hFf/V0oAAA==',
  '/images/activity arcade/Bento Grid/nutraswiss spa.webp': 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAADwAQCdASoQABAABUB8JZgCdADcIYx3+8AA9wkczESZZe4/EPvTXA4jFFCalrHAAAA=',
  '/images/activity arcade/Bento Grid/Cinema 3_2.webp': 'data:image/webp;base64,UklGRjQAAABXRUJQVlA4ICgAAADwAQCdASoQABAABUB8JYwCsADGYJsOOAAA/uWanbL0WAczuAx7YEAA',
  '/images/activity arcade/Bento Grid/Cinema 3_2_mobile.webp': 'data:image/webp;base64,UklGRjQAAABXRUJQVlA4ICgAAADwAQCdASoQABAABUB8JYwCsADGYJsOOAAA/uWanbL0WAczuAx7YEAA',
  '/images/activity arcade/Bento Grid/Billiards Room 3_2.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAACwAQCdASoQABAABUB8JYgCdACPdAQAAPcGz1ZwYbJBOWJD8zxA81pDCr/AAA==',
  '/images/activity arcade/Bento Grid/Billiards Room 3_2_mobile.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAACwAQCdASoQABAABUB8JYgCdACPdAQAAPcGz1ZwYbJBOWJD8zxA81pDCr/AAA==',
  '/images/activity arcade/Bento Grid/pool_compressed.optimized.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAACQAQCdASoQABAABUB8JbACdLoAA5gA/rf9NT/mSPXkUu0lj/o8sXw5YQAAAA==',
  '/images/activity arcade/Bento Grid/Tennis 3_2.webp': 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAABwAQCdASoQABAABUB8JbACdABbgADKo/C9lf5oK1L2cUkAupTwS0oSMjPL47Wj6AA=',
  '/images/activity arcade/Bento Grid/Tennis 3_2_mobile.webp': 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAABwAQCdASoQABAABUB8JbACdABbgADKo/C9lf5oK1L2cUkAupTwS0oSMjPL47Wj6AA=',
  '/images/jungfrau dark.webp': 'data:image/webp;base64,UklGRsoAAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSHUAAAAFuQpE9D80kCJJciSt5I/3tOgGEQsgLP9lCaBhREzABFxy9eNG2m/NoOjdjDTpF+hytElDi54ZswitDrQpDoUHIUmZUdpDk9TZJPSVFOcg0FeS6CgWfNcADi0Ib0pRCsWZsLftMLIvq85ZuojI06aAsi+liAgAVlA4IC4AAABwAQCdASoQABAABUB8JaWM+AGIAAD+759LFE8emfKCrU6kz7qgRJB7pTi8AAAA',
  '/images/NUTRASWISS-LOGO.png': 'data:image/webp;base64,UklGRnwAAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSB0AAAABD9D/iAiYadsmUvlzKpRCGIO8gxDR/1RGKY/lVABWUDggOAAAANABAJ0BKhAAEAAFQHwlsAJ0AQ5Od7oAAMpuhalh+70LND9Kazh1MteJAYz/kQVshaQOSFuGfAAA',
  '/images/Carbon mountain cafe logo.png': 'data:image/webp;base64,UklGRgABAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSLgAAAANuS5E9D80cBzJdq3Imx+z/zV672ETc4Q3o/kfonc0pE9HIr0Xm0RMQE7Om1ixDEe2bXjfcQhL1qzKM/96PaE503WpNjT+PJ5rPnbqxuQCVupD0UYVfQMs6qNuhghUkaliv2mOpuoEHJF5Mx0asgjAVpD1X87EtUVSm8oADQAijPcOW7i2ouUeF5QWIAegUWIpUnIo2TnmTWQGIFf2nI413BiEnVU3+alWwzQNFPpN8YMORxJ0r8wGVlA4ICIAAABQAQCdASoQABAABUB8JagABAAAAP7iiNpyf9VU9fpWAAAA',
  '/BRS-Full-logo.webp': 'data:image/webp;base64,UklGRggBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSJMAAAANd6CobSOm5U+4r3EDREQk+JUz3Gbb3Ca6TnTn7JJcO06ghwnsFZiB9nB1cmU6pwHI0MMGMpOwUET/A5PdujE3PVf7rJ0efVQctu//b7BUmTbmq3G5hGOra+SunidVdTqba1ykFl2mMSrzJXWfDlVqU9vOwoVjEQsggZZkKQgsIJYChQUkOSQLLMnMaFlA1BLOLQEAVlA4IE4AAAAQAgCdASoQABAABUB8JbACdAYq78rKpW1AAPt0qbmzqbZjKCaT01Tylk0/xXD98KnXin46lNSJXSRG5NYvERUc6q5/8GyQbvtRmrhMAAA=',
  '/images/activity arcade/activity-arcade-why-choose-us-mobile.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAACQAQCdASoQABAABUB8JZgCdAEHeYAA/dexRNZ+O58ETqmY2s54pRsTsAAAAA==',
  '/images/activity arcade/Relaxing Massage.jpg': 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAAAQAgCdASoQABAABUB8JbACdAERFV2vnPB0AN1CiPwETPp57OPsOO9y0SR4D/0h4AA=',
  '/images/activity arcade/Whirlpool-mobile.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAACQAQCdASoQABAABUB8JYgCdADWGfAA/JxUoS+7LyNKahmO/LFPX4NIlsAAAA==',
  '/images/activity arcade/Sauna-mobile.webp': 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAADQAQCdASoQABAABUB8JbACdAEIMWfBAAD+cAeRnJPjdXIrnF+97lorAs7VrzSAAAA=',
  '/images/activity arcade/Relaxation-Terrace-mobile.webp': 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAABwAQCdASoQABAABUB8JZgCdAAAAAD96QUuu3tEM71re0I+k1W2v/dRagnIAAAA',
  '/images/activity arcade/Gourmet-meals-mobile.webp': 'data:image/webp;base64,UklGRjYAAABXRUJQVlA4ICoAAADQAQCdASoQABAABUB8JZQAAuP0o6NYAAD97M+DxVH6CP372cnNL/RAAAA=',
  '/images/activity arcade/Quick-bites-mobile.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAACQAQCdASoQABAABUB8JYgCdABCHAAA2tRamIB2c6ecFZkPHptiLWLfufpQAA==',
  '/images/activity arcade/bar and lounge.webp': 'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAAAwAgCdASoQABAABUB8JZACw7EO/yEqZza4eAD+w60qd6l+zoRATyAO+SQAAA==',
  '/images/activity arcade/views.webp': 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAADQAQCdASoQABAABUB8JbACdAEOtvx9yAD9zuf6e9TGzHQyEh/rjYD/b8/XosO6AAA=',
  '/images/activity arcade/fitness centre.webp': 'data:image/webp;base64,UklGRjYAAABXRUJQVlA4ICoAAACQAQCdASoQABAABUB8JQBYdhLIwAAA9ya07xW8xibafNlEeA+NyC4AAAA=',
  '/images/activity arcade/Tennis-closeup-4-3-mobile.webp': 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAACQAQCdASoQABAABUB8JbACdABJWrgA9wZXMh2iO3XfWduDZIpuR5T0ygwy9GsAAAA=',
};

/**
 * Get blur placeholder data URL for an image.
 * 
 * @param imagePath - The image path (as used in src prop)
 * @returns Blur placeholder data URL, or undefined if not found
 */
export function getBlurPlaceholder(imagePath: string): string | undefined {
  // Try exact match first
  if (blurPlaceholderMap[imagePath]) {
    return blurPlaceholderMap[imagePath];
  }
  
  // Try with leading slash removed
  const pathWithoutLeadingSlash = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  if (blurPlaceholderMap[pathWithoutLeadingSlash]) {
    return blurPlaceholderMap[pathWithoutLeadingSlash];
  }
  
  // Try with leading slash added
  const pathWithLeadingSlash = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  if (blurPlaceholderMap[pathWithLeadingSlash]) {
    return blurPlaceholderMap[pathWithLeadingSlash];
  }
  
  // Try matching mobile/PC variants
  if (imagePath.includes('_mobile.webp')) {
    const pcVariant = imagePath.replace('_mobile.webp', '.webp');
    if (blurPlaceholderMap[pcVariant]) {
      return blurPlaceholderMap[pcVariant];
    }
  }
  
  if (imagePath.includes('_pc.webp')) {
    const baseVariant = imagePath.replace('_pc.webp', '.webp');
    if (blurPlaceholderMap[baseVariant]) {
      return blurPlaceholderMap[baseVariant];
    }
  }
  
  return undefined;
}

/**
 * Set blur placeholder for an image path.
 * Used by build scripts to populate the map.
 */
export function setBlurPlaceholder(imagePath: string, dataURL: string): void {
  blurPlaceholderMap[imagePath] = dataURL;
}

/**
 * Get all blur placeholders (for build scripts).
 */
export function getAllBlurPlaceholders(): Record<string, string> {
  return { ...blurPlaceholderMap };
}
